<script>
import axios from "axios";
import { version } from "@/../package.json";

export default {
  name: "VersionCheck",
  emits: ["updateAvailable"],
  props: {
    delay: {
      type: Number,
      default: 300000 // 5 minutes
    }
  },
  computed: {
    version() {
      return version;
    }
  },
  data() {
    return {
      intervalId: 0
    };
  },
  methods: {
    compareVersions() {
      console.log("Checking version...");
      axios
        .get("./index.html?ts=" + Date.now())
        .then((response) => response.data)
        .then((response) => {
          const domParser = new DOMParser();
          const dom = domParser.parseFromString(response, "text/html");
          const meta = dom.querySelector("meta[name='version']");
          if (!meta) {
            console.error("Version tag not found");
            return;
          }
          const version = meta.getAttribute("content");
          console.log("Current version: ", this.version);
          console.log("Latest version: ", version);
          if (version !== this.version) {
            this.$emit("updateAvailable");
          }
        });
    }
  },
  render() {
    return null;
  },
  mounted() {
    this.compareVersions();
    this.intervalId = setInterval(this.compareVersions, this.delay);
  },
  unmounted() {
    clearInterval(this.intervalId);
  }
};
</script>
